import { mapProviders } from 'constants/maps';
import type { AccidentDetails } from 'ts/types/case-creation.types';
import type { TemporalLocation } from 'ts/types/location.types';
import type { DecisionTreeDataResultModel } from 'redux/actions/caseCreationActions.types';

export const NO_DAMAGE = 'NO_DAMAGE';
export const DEFAULT_PLACE_TYPE = 'OTHER';

export const getAccidentData = (data?: Partial<AccidentDetails>) => {
  let vehicle_damage;

  if (data?.type_of_damage) {
    vehicle_damage = data.type_of_damage.toUpperCase();
  } else {
    vehicle_damage = NO_DAMAGE;
  }

  return {
    initial_situation_assessment: {
      is_vehicle_in_mud_or_a_ditch: data?.is_car_in_mud || false,
      has_no_longer_wheels: data?.is_no_longer_on_wheels || false,
      is_police_called: data?.is_police_on_its_way || false,
      is_thirdparty_involved: data?.is_thirdparty_involved || false,
      is_wheels_blocked_or_missing: data?.is_wheels_blocked_or_missing || false,
      vehicle_damage,
    },
  };
};

export const getCustomerData = (
  isPolicyHolder: any,
  personName: any,
  personSurname: any,
  phoneCountryCodeContact: any,
  phoneNumberContact: any,
) => {
  const isPolicyHolderParsed = getPolicyHolder(isPolicyHolder);
  const contactPhone = {
    international_prefix: phoneCountryCodeContact,
    number: phoneNumberContact,
  };

  if (isPolicyHolderParsed) {
    return {
      contact_phone: contactPhone,
      is_policy_holder: isPolicyHolderParsed,
    };
  }

  return {
    contact_phone: contactPhone,
    first_name: personName,
    is_policy_holder: isPolicyHolderParsed,
    last_name: personSurname,
  };
};

export const getLocationByMapProvider = (
  mapProvider: keyof typeof mapProviders,
  currentLocation?: Partial<TemporalLocation> | undefined,
) => {
  const commonParams = {
    locality: currentLocation?.address?.locality,
    postal_code: currentLocation?.address?.postalCode,
    street_address: currentLocation?.address?.formattedAddress,
  };

  let country: string | undefined;

  if (mapProvider === 'GOOGLE') {
    country = currentLocation?.address?.countryRegionIso2;
  }

  if (mapProvider === 'BING') {
    country = currentLocation?.address?.country;
  }

  return {
    ...commonParams,
    country,
  };
};

export const getCause = (decisionTreeResult: DecisionTreeDataResultModel) => {
  if (decisionTreeResult.code) {
    return {
      code: decisionTreeResult.code,
      description: decisionTreeResult.description,
    };
  } else {
    return undefined;
  }
};

/**
 * @todo
 * This needs to be modified to receive status as parameter.
 * The HTTP error code that we will use es 409.
 * @return status === 409
 */
export const isDuplicateCase = (res?: any) => {
  return res?.duplicate;
};

export const getPlaceType = (currentLocation?: {
  is_at_motorway?: boolean;
}) => {
  if (currentLocation?.is_at_motorway) {
    return 'HIGHWAY';
  } else {
    return DEFAULT_PLACE_TYPE;
  }
};

export const getServiceAppointment = (serviceAppointment?: any) => {
  const hasAppointment = serviceAppointment !== undefined;

  const bodyWithNoDate = { is_scheduled: hasAppointment };

  if (hasAppointment) {
    return { ...bodyWithNoDate, scheduled_at: serviceAppointment };
  } else {
    return bodyWithNoDate;
  }
};

export const getSpecialRequirements = (passengersDetails = {}) => {
  const hasPassengersDetails = Object.keys(passengersDetails).length > 0;

  if (hasPassengersDetails) {
    const normalizedRequirements = JSON.stringify(passengersDetails);
    return {
      special_requirements: normalizedRequirements,
    };
  }
  return {};
};

export const getPolicyHolder = (value?: 'yes' | 'no') => {
  if (value === 'yes') {
    return true;
  }

  if (value === 'no') {
    return false;
  }

  return undefined;
};

export const getVehicleDetails = (plateNumber: string, vehicleDetails = {}) => {
  return {
    registration_number: plateNumber,
    ...vehicleDetails,
  };
};
